import { Action, ActionType } from '../actions';
import { Notification } from '../../interfaces/Notification';

export const addNotifications = (notifications: Notification[]): Action => {
  return { type: ActionType.ADD_NOTIFICATIONS, payload: notifications };
};

export const removeNotification = (id: string): Action => {
  return { type: ActionType.REMOVE_NOTIFICATION, payload: id };
};
